<template>
  <div id="contact" class="page">
    <section class="contact-section section-padding">
      <div class="container">
        <div class="row">
          <div class="col col-md-4 col-md-6">
            <div class="contact-section-contact-box">
              <div class="section-title-white">
                <h2>Contact</h2>
              </div>
              <div class="details">
                <p>Pour toutes questions techniques ou commerciales, nos équipes sont là pour vous répondre rapidement.</p>
                <ul>
                  <li><i class="fa fa-phone"></i> 03 20 07 05 04</li>
                  <li><i class="fa fa-envelope"></i> contact@oxynov.fr</li>
                  <li><i class="fa fa-home"></i> 2 rue de la Carnoy, 59130 Lambersart</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col col-lg-6 col-lg-offset-1 col-md-7">
            <div class="section-title-white">
              <h2>Vos coordonnées</h2>
            </div>
            <p></p>
            <div class="contact-form-s1 form">
              <form @submit.prevent="submitForm" v-if="!formSuccess" method="post" id="contact-form" class="wpcf7-form contact-validation-active">
                <div>
                  <label for="name">Nom <span class="required">*</span></label>
                  <input type="text" v-model="form.last_name" id="last_name" name="last_name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('last_name') }">
                </div>
                <div>
                  <label for="name">Prénom <span class="required">*</span></label>
                  <input type="text" v-model="form.first_name" id="first_name" name="first_name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('first_name') }">
                </div>
                <div>
                  <label for="email">Email <span class="required">*</span></label>
                  <input type="email" v-model="form.email" id="email" name="email" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('email') }">
                </div>
                <div>
                  <label for="phone">Numéro de téléphone <span class="required">*</span></label>
                  <input type="text" v-model="form.phone" id="phone" name="phone" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('phone') }">
                </div>
                <div style="width: 100%;">
                  <label for="textaera">Message <span class="required">*</span></label>
                  <textarea id="message" v-model="form.message" name="message" v-validate="'required'" class="form-control" rows="5" style="height: auto; resize: vertical;" :class="{'input': true, 'is-danger': errors.has('message') }"></textarea>
                </div>
                <div class="submit-btn-wrap">
                  <button type="submit" class="btn btn-primary btn-outlined btn-block">Envoyer</button>
                </div>
              </form>
              <div v-if="formSuccess" class="error-handling-messages">
                <div class="alert alert-success">
                  <strong><i class="fa fa-check"></i> Merci !</strong>
                  Nous avons bien pris en compte votre demande.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import axios from 'axios'

Vue.use(VeeValidate)

export default {
  name: 'Contact',
  data () {
    return {
      apiUrl: window.location.hostname === 'www-oxynov-fr-forestia.c9users.io' ? 'https://api-v1-forestia.c9users.io' : 'https://api.decklinea.com',
      isLoading: false,
      formSuccess: false,
      form: {
        first_name: '',
        last_name: '',
        email: '',
        forwardTo: 'cfelix@decklinea.com',
        message: ''
      }
    }
  },
  methods: {
    submitForm () {
      let vm = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          vm.isLoading = true
          axios.post(vm.apiUrl + '/api/contact?api_token=$2y$10$feg/vmqx0YY151l7tk2e4..JiR5O/Tn6GaNWUdSvsL1evmgks.ZTS', vm.form)
            .then(function (response) {
              if (response.data === 'success') {
                vm.resetForm()
              }
            })
            .catch(function (error) {
              vm.isLoading = false
              console.log(error)
            })
          return false
        }
      })
    },
    resetForm () {
      this.isLoading = false
      this.formSuccess = true
      this.form = {
        first_name: '',
        last_name: '',
        email: '',
        forwardTo: 'cfelix@decklinea.com',
        message: ''
      }
      this.$nextTick(() => {
        // eslint-disable-next-line
      	this.$validator.reset()
      })
    }
  }
}
</script>

<style scoped>
.contact-section {
  background: #f7f7f7;
}
.contact-section:before {
  content: unset;
}
.contact-section h2,
.contact-section ul,
.contact-section label {
  color: inherit;
}
.contact-section select {
  line-height: 29px;
}
.contact-section textarea {
  border: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.contact-section textarea:focus {
  border-color: #051829;
  box-shadow: 0 0 5px 0 #0b3356;
}
.contact-section .btn {
  border-color: #005e90;
}
.contact-section .required {
  color: #851326;
}
.contact-section .fa-check {
  color: #47b475;
}
.contact-section .input.is-danger {
  border: solid 1px #851326;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Contact.vue